import React from "react";
import { t } from "@lingui/macro";

import ShorexIcon from "./ShorexIcon";
import { IconName } from "@silversea-ssc/ui-components-react";

export interface DefaultShorexIconProps {
  iconName: IconName;
  showDescription?: boolean;
  showLabel?: boolean;
  showLabelMobile?: boolean;
  className?: string;
  iconClassName?: string;
  size: "small" | "big";
}

const iconMapping = {
  privato: {
    label: t`Privato`,
    description: t`Privato`
  },
  "evening-excursions": {
    label: t`Evening Excursions`,
    description: t`This excursion will take place in the evening`
  },
  new: {
    label: t`New Excursion`,
    description: t`This shore excursion is brand new to Silversea`
  },
  "free-shorex": {
    label: t`Free Shorex`,
    description: t`Free Shorex`
  },
  "meal-included": {
    label: t`Meal Included`,
    description: t`A meal is included in the excursion.`
  },
  "limited-space-available": {
    label: t`Limited Space Available`,
    description: t`Limited Space Available`
  },
  "world-cruise-collection": {
    label: t`World Cruise Collection`,
    description: t`This excursion is offered exclusively to Silversea World Cruise guests`
  },
  "special-price": {
    label: t`Special Price`,
    description: t`Special Price`
  }
};

const DefaultShorexIcon: React.FC<DefaultShorexIconProps> = (props) => {
  const label = iconMapping[props.iconName]?.label;
  const description = iconMapping[props.iconName]?.description;

  return <ShorexIcon {...props} label={label} description={description} />;
};

export default DefaultShorexIcon;
